import Refresh from "src/components/shared/refresh";

function clearCookiesData() {
    Cookies.remove("JSESSIONID", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("RefreshRate", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("credentials", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("VT-On-Behalf-Of", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("userRoles", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("isTopLevelAccount", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("isPrimaryAccountReseller", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("canConfigureVBUSDeviceTab", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("viewport", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("driversTZ", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("routes", {
        path: "/",
        secure: true,
        sameSite: "None"
    });

    Cookies.remove("refreshRateInterval", {
        path: "/",
        secure: true,
        sameSite: "None"
    });
}

function toggleCodeNotification(responseData, serverCode) {
    const message1 = Locale.translate("An unexpected error occurred. Try reloading the page or contacting your service provider if the problem persists.");
    const message2 = Locale.translate("Reference #");

    if ("message" in responseData) {
        toastr.error(`${message1} <br/> ${message2}${serverCode}: ${responseData.message}`);
    } else {
        toastr.error(`${message1} <br/> ${message2}${serverCode}:`);
    }
}

function toggleResponseStatusNotification(responseData) {
    if (!responseData || !("status" in responseData)) {
        toastr.error(
            Locale.translate(
                "Internal Server Error encountered while attempting to contact the server. Please reload your browser. If the problem persists, please contact your Administrator."
            )
        );
        return;
    }
    if ("status" in responseData && responseData.status === 400) {
        if ("responseText" in responseData && responseData.responseText) {
            toastr.error(responseData.message);
        } else {
            toastr.error(
                Locale.translate(
                    "Error 400 (Bad Request) encountered while attempting to contact the server. Please reload your browser. If the problem persists, please contact your Administrator."
                )
            );
        }
        return;
    }

    if ("status" in responseData && responseData.status === 403) {
        if ("responseText" in responseData && responseData.responseText) {
            toastr.error(responseData.responseText);
        } else {
            toastr.error(
                Locale.translate(
                    "Error 403 (Forbidden) encountered while attempting to contact the server. Please reload your browser. If the problem persists, please contact your Administrator."
                )
            );
        }
        return;
    }

    if ("status" in responseData && responseData.status === 404) {
        if ("responseText" in responseData && responseData.responseText) {
            toastr.error(responseData.responseJSON.message);
        } else {
            toastr.error(
                Locale.translate(
                    "Error 404 (Not Found) encountered while attempting to contact the server. Please reload your browser. If the problem persists, please contact your Administrator."
                )
            );
        }
        return;
    }

    // Redirect back to login page
    if ("status" in responseData && responseData.status === 401) {
        Refresh.clear();
        Refresh.unbind("interval.value");
        clearCookiesData();
        location.replace("login.html");
        return;
    }

    // Redirect to the login page.
    if (
        "status" in responseData &&
        "responseText" in responseData &&
        [500, 503, 504].includes(responseData.status)
    ) {
        if (responseData.responseText.indexOf("Your session has timed-out.") >= 0) {
            Refresh.clear();
            Refresh.unbind("interval.value");
            clearCookiesData();
            location.replace("login.html");
            return;
        }

        let message = Locale.translate("504 Gateway Time-out Occurred");
        if (
            "responseJSON" in responseData &&
            "message" in responseData.responseJSON &&
            responseData.responseJSON.message
        ) {
            message = responseData.responseJSON.message;
        }

        toastr.error(message);
    } else {
        toastr.error(
            Locale.translate(
                "Internal Server Error encountered while attempting to contact the server. Please reload your browser. If the problem persists, please contact your Administrator."
            )
        );
    }

    if (
        "status" in responseData &&
        [502].includes(responseData.status)
    ) {
        toastr.error(Locale.translate("502 Bad Gateway."));
    }
}

export function errorHandler(responseData) {
    console.log(responseData);
    if (
        responseData && 
        typeof responseData === "object" &&
        responseData.responseJSON &&
        typeof responseData.responseJSON === "object" &&
        "code" in responseData.responseJSON
    ) {
        const errorCodes = [500, 19203, 19204, 19205];
        const jsonCode = responseData.responseJSON.code;
        const hasError = errorCodes.includes(jsonCode);

        if (hasError) {
            toggleCodeNotification(responseData.responseJSON, jsonCode);
            return;
        }

        toggleResponseStatusNotification(responseData);
    } else {
        toggleResponseStatusNotification(responseData);
    }
}
